import React from "react"

import "./index.scss"

const CaseCustomHeader = ({
    caseName,
    header,
    duration,
    industry,
    location,
    team,
}) => {
    return (
        <div className="case-custom-header">
            {caseName && <h2 className="t-s5">{caseName}</h2>}
            <div className="case-custom-header-absolute">
                {header && <h1 className="t-h1-m">{header}</h1>}
                <div className="case-custom-header-info">
                    {duration && (
                        <span className="case-custom-header-info-item">
                            <h6 className="t-b3">Duration - </h6>
                            <span className="t-b3">{duration}</span>
                        </span>
                    )}
                    {industry && (
                        <span className="case-custom-header-info-item">
                            <h6 className="t-b3">Industry - </h6>
                            <span className="t-b3">{industry}</span>
                        </span>
                    )}
                    {location && (
                        <span className="case-custom-header-info-item">
                            <h6 className="t-b3">Location - </h6>
                            <span className="t-b3">{location}</span>
                        </span>
                    )}
                    {team && (
                        <span className="case-custom-header-info-item">
                            <h6 className="t-b3">Team - </h6>
                            <span className="t-b3">{team}</span>
                        </span>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CaseCustomHeader
